import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

/**
 * Centralized API timeout presets (ms). Pass via per-call config to override:
 *   webAppApi.someResource.someCall(payload, { timeout: ApiTimeout.VeryLong })
 *   EOneRequest.post(url, body, { timeout: ApiTimeout.Long })
 */
export const ApiTimeout = {
  Default: 30_000,
  Long: 60_000,
  VeryLong: 300_000,
} as const;

export type ApiTimeoutKey = keyof typeof ApiTimeout;

const eOneInstance = axios.create({
  baseURL: '/',
  timeout: ApiTimeout.Default,
  headers: {
    'Content-Type': 'application/json',
  },
});

const request = async <T = any>(config: AxiosRequestConfig): Promise<T> => {
  const response = await eOneInstance.request<T>(config);
  return response as T;
};

const get = <T = any>(url: string, params?: any, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'get', url, params });

const post = <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'post', url, data });

const put = <T = any>(url: string, data?: any, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'put', url, data });

const del = <T = any>(url: string, config?: AxiosRequestConfig) =>
  request<T>({ ...config, method: 'delete', url });

const EOneRequest = {
  request,
  get,
  post,
  put,
  del,
};

export { EOneRequest, eOneInstance };
